import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GiftcardsService {


  url = environment.serverAPI5 + "/api";
	ur2 = environment.serverAPI5 + "/api/giftcards";

	constructor(private http: HttpClient) { }

	newgiftcards(giftcards: any): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url}/giftcards`, giftcards)
	}
	getgiftcards(Page: any, size: any, sort: any): Observable<Object> {
		return this.http.get(`${this.ur2}?page=${Page}&size=${size}&sort=${sort}`);
	}

	giftcards(Page: number, size: number, sort): Observable<Object> {
		return this.http.get(`${this.url}/giftcards?page=${Page}&size=${size}&sort=${sort}`);
	}

	giftcardsSearch(query: any, Page: any, size: any, sort: any): Observable<Object> {

		return this.http.get(`${this.url}/giftcards/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
	}
	deleteByGiftcardsId(id: any): Observable<Object> {
		return this.http.delete(`${this.url}/giftcards/${id}`);
	}
	downloadgiftcardsTemplate(): Observable<any> {
		return this.http.get(`${this.url}/giftcards/template/download`, { responseType: 'arraybuffer', observe: 'response' });
	}
	downloadgiftcardsReport(Page: number, size: number, sort, selectionCategories): Observable<any> {
		return this.http.post(`${this.ur2}/export/page?page=${Page}
		&size=${size}&sort=${sort}`, selectionCategories, {
			responseType: 'arraybuffer',
			observe: 'response'
		});
	}
}
